import { useEffect, useState } from "react"
import { api } from "../../env"
import DashboardTrackSummary from "./Track"
import { useParams } from "react-router-dom"
import { setStorage, STORAGE } from "../../utils/storage"
import DashboardHeader from "./DashboardHeader"

export default function Dashboard() {

    const [enrollment, setEnrollment] = useState(undefined)
    const [track, setTrack] = useState(undefined)
    const [match, setMatch] = useState(undefined)
    const { id } = useParams()
    
    useEffect(() => {
        api.get(`enrollments/${id}`)
            .then(res => setEnrollment({...res.data, id }))
            .catch(_ => console.log("Error fetching enrollment"))
    }, [id])

    useEffect(() => {
        if (enrollment) {
            setTrack(enrollment.trackInstance)
            setMatch({
                ...(enrollment.type == 'Mentor' ? enrollment.matchProposal?.menteeDetails : enrollment.matchProposal?.mentorDetails),
                type: enrollment.type == 'Mentor' ? 'Mentee' : 'Mentor'
            })
            setStorage(STORAGE.USER_ROLE, enrollment.type)
            setStorage(STORAGE.PARTICIPANT_ROLE, enrollment.type)
        }
    }, [enrollment])

    const markAsCompleted = (itemId) => {
        setTrack(prev => ({
            ...prev,
            chapters: prev.chapters.map(chapter => {

            const activities = (chapter.activities ?? []).map(activity =>
                activity.id === itemId ? { ...activity, isCompleted: true } : activity
            )

            const sparks = (chapter.sparks ?? []).map(spark =>
                spark.id === itemId ? { ...spark, isCompleted: true } : spark
            )
            
            const done = activities.length > 0 && activities.every(a => a.isCompleted) && sparks.length > 0 && sparks.every(s => s.isCompleted)

            return done && !chapter.isCompleted
                ? { ...chapter, activities, sparks, isCompleted: true }
                : { ...chapter, activities, sparks }
            })
        }))
    }

    return(

        <div className="page">
            <div> <DashboardHeader match={match} emails={enrollment?.contactEmails} companyName={enrollment?.companyName ?? 'Us'}/></div>
            <main className="silent-scroll">
                <div className="standard-padding showing">
                    <DashboardTrackSummary track={track} enrollment={enrollment} matchType={match?.type ?? 'Companion'} onItemCompleted={markAsCompleted}/>
                </div>
            </main>
        </div>
    )
}